import { useTranslation } from 'react-i18next'
import { localizedRoutes, type RouteKey } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

/**
 * Hook to get a localized href for a route key or path.
 * Similar to LocalizedLink but returns just the href string.
 */
export function useLocalizedHref(to: RouteKey | string): string {
  const { i18n } = useTranslation()
  const currentLang = i18n.language as SupportedLanguage

  if (to in localizedRoutes) {
    const routeKey = to as RouteKey
    const localizedPath = localizedRoutes[routeKey][currentLang]
    return localizedPath ? `/${currentLang}/${localizedPath}` : `/${currentLang}`
  } else if (to.startsWith('/')) {
    // Absolute path - add language prefix
    return `/${currentLang}${to}`
  } else if (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    // External link - pass through
    return to
  } else {
    // Relative path - add language prefix
    return `/${currentLang}/${to}`
  }
}
